/*
 * File: /src/store/modules/customFields.js
 * Created Date: Sunday November 15th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 15th November 2020 11:44:26 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */
import Vue from 'vue';
import customFieldService from 'src/services/customFieldServices';

const state = {
  fields: []
};
const getters = {
  getCustomFields: state => {
    return state.fields;
  },
  getContactCustomFields: (state) => {
    return  state.fields.filter(
    (f) => {return f.object_type == 'contact'});
  },
  getLeadCustomFields: (state) => {
    return  state.fields.filter(
    (f) => {return f.object_type == 'lead'});
  },
};
// Cant remember why we added explicit data but I think it had to do with binding
// Standardized this into a single function now to reduce duplication
// TODO: append this with the fields for contacts
const projectionFields = (cf) => ({
  id: cf.id,
  field_name: cf.field_name,
  object_type: cf.object_type,
  values: cf.values,
  data_type: cf.data_type,
  label: cf.label,
  is_required: cf.is_required,
  lead_type_ids: cf.lead_type_ids,
  display_order: cf.display_order,
  profile_id: cf.profile_id,
  required_types: cf.required_types,
});

const actions = {
  fetchCustomFields({ commit }) {
    if (state.fields.length === 0) {
      return customFieldService.fetchCustomFields()
      .then(r => {
        commit('setCustomFields', r.data.map(projectionFields));
      });
    }
  },
  /**
   * force a cache break on this data as needed
   */
  reloadCustomFields({ commit }) {
    return customFieldService.fetchCustomFields()
      .then(r => {
        commit('setCustomFields', r.data.map(projectionFields));
      });
  },
  unloadCustomFields({ commit }) {
    commit('setCustomFields', []);
  },
};
const mutations = {
  setCustomFields(state, fields) {
    state.fields = Object.assign([], fields);
    // Vue.set(state, 'fields', fields);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
